import gql from 'graphql-tag';
// Active students radial chart
const GET_ACTIVE_STUDENTS_REPORT = gql`
  query getActiveStudentsReport($where: PrmActiveStudentsReportWhereInput!) {
    prmActiveStudentsReport(where: $where) {
      activeStudentCount
      totalStudentCount
    }
  }
`;

export default GET_ACTIVE_STUDENTS_REPORT;
